import { ApolloClient, InMemoryCache, ApolloLink, HttpLink, concat } from '@apollo/client';
import { getAuth } from 'firebase/auth';
import { currentRegion } from '../../config/regions';

const authLink = new ApolloLink(async (operation, forward) => {
    const auth = getAuth();
    if (auth.currentUser) {
        const idTokenResult = await auth.currentUser.getIdTokenResult(true);
        operation.setContext({
            headers: {
                Authorization: `Bearer ${idTokenResult.token}`,
            },
        });
    }
    return forward(operation);
});

// GraphQL service of the region this page load runs in (the region is fixed per page load; see config/regions).
const httpLink = new HttpLink({ uri: currentRegion.graphqlUrl });

const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: concat(authLink, httpLink),
});

export default client;
